import type { OverviewResponse } from "contracts/api/dashboard/responses";
import type { Accessor } from "solid-js";
import { For, Show } from "solid-js";
import {
  pageDisplayLabel,
  rawPagePath,
} from "../pages/boundaries/page-label.parser";
import { issuesForPage } from "./scanExperienceModel";

type Page = OverviewResponse["pages"][number];

export function PagesInventoryPane(props: {
  data: OverviewResponse;
  visiblePages: Accessor<Page[]>;
  selectedPage: Accessor<Page | null>;
  selectedPageHidden: Accessor<boolean>;
  activeScore: (page: Page) => number | null;
  onSelect: (pageId: string) => void;
  onReveal: () => void;
}) {
  return (
    <div class="signal-pane signal-inventory-pane">
      <div class="signal-pane-head">
        <h2>Pages in current scan</h2>
        <span>{props.visiblePages().length}</span>
      </div>
      <Show when={props.selectedPageHidden()}>
        <div class="signal-selection-notice" aria-live="polite">
          <span>Selected page is hidden by current filters</span>
          <button type="button" onClick={props.onReveal}>
            Reveal in list
          </button>
        </div>
      </Show>
      <Show
        when={props.data.pages.length > 0}
        fallback={
          <p class="signal-muted">
            No pages are available in the current completed scan inventory.
          </p>
        }
      >
        <div class="signal-page-inventory">
          <Show
            when={props.visiblePages().length > 0}
            fallback={
              <p class="signal-muted">No pages match the current filters.</p>
            }
          >
            <For each={props.visiblePages()}>
              {(page) => (
                <button
                  data-page-id={page.id}
                  type="button"
                  class={`signal-page-result ${
                    props.selectedPage()?.id === page.id ? "is-active" : ""
                  }`}
                  onClick={() => props.onSelect(page.id)}
                >
                  <span>
                    <strong>{pageDisplayLabel(page, props.data.site)}</strong>
                    <small class="mono">{rawPagePath(page)}</small>
                  </span>
                  <span class="signal-page-result-meta">
                    <b>{props.activeScore(page) ?? "--"}</b>
                    <small>
                      {issuesForPage(props.data, page).length} issue
                      {issuesForPage(props.data, page).length === 1 ? "" : "s"}
                    </small>
                  </span>
                </button>
              )}
            </For>
          </Show>
        </div>
      </Show>
    </div>
  );
}
